import { useState, useEffect, useContext } from "react";
import {
  getDocumentsStatus,
  uploadVerificationDocument,
} from "../../../services/kyb-verification";
import { ToastContext, RequestLoader } from "../../../hooks/context";
import { useStep } from "react-hooks-helper";

const KYBVerificationLogic = () => {
  const [business_type, setBusinessType] = useState("individual"); // individual | LLC | sole_propietor
  const [isFetchingDocuments, setIsFetchingDocuments] = useState(false);
  const [verificationData, setVerificationData] = useState(null);
  const triggerToast = useContext(ToastContext);
  const { setRequestLoaderProgress } = useContext(RequestLoader);
  const { index, navigation } = useStep({ initialStep: 0, steps: 2 });

  useEffect(() => {
    fetchDocuments(true);
  }, []);

  const fetchDocuments = (showLoader = true) => {
    if (showLoader) setIsFetchingDocuments(true);
    setRequestLoaderProgress(40);
    getDocumentsStatus()
      .then((response) => {
        setVerificationData(response?.data?.data);
      })
      .finally(() => {
        setIsFetchingDocuments(false);
        setRequestLoaderProgress(100);
      });
  };

  const handleDocumentUpload = (document) => {
    setRequestLoaderProgress(40);
    const formData = new FormData();
    formData.append("type", document.type);
    formData.append("file", document.file);
    uploadVerificationDocument(formData)
      .then(() => {
        setRequestLoaderProgress(100);
        triggerToast("Document successfully uploaded", "success");
        fetchDocuments(false);
      })
      .finally(() => setRequestLoaderProgress(100));
  };

  return {
    business_type,
    verificationData,
    isFetchingDocuments,
    setBusinessType,
    handleDocumentUpload,
    fetchDocuments,
    step: index,
    navigation,
  };
};

export default KYBVerificationLogic;
